import { isValidAutomergeUrl, parseAutomergeUrl, stringifyAutomergeUrl, } from "@automerge/automerge-repo/slim";
import { isKeyhiveDoc } from "./keyhive.js";
const splitImportUrl = (importUrl) => {
    if (!isValidAutomergeUrl(importUrl))
        return { url: importUrl, frozen: undefined };
    const { documentId, heads } = parseAutomergeUrl(importUrl);
    if (!heads)
        return { url: importUrl, frozen: undefined };
    return { url: stringifyAutomergeUrl({ documentId }), frozen: importUrl };
};
/** Creates a new document initialized with the given datatype using create2 */
export const createDocOfDatatype2 = async (datatype, repo, change, hive) => {
    const handle = await repo.create2();
    // Add sync server with relay access
    if (hive && isKeyhiveDoc(handle.url)) {
        await hive.addSyncServerRelayToDoc(handle.url);
    }
    handle.change((doc) => {
        datatype.module.init(doc, repo);
        // Record the datatype's import URL so a viewer with no built-in tool can
        // load one. It may be an `http:`/`https:` module bundle or an `automerge:`
        // folder-doc URL; both are honored on read via `getSuggestedImportUrl`.
        const { url: importUrl, frozen } = splitImportUrl(datatype.importUrl);
        doc["@patchwork"] = {
            type: datatype.id,
            ...(importUrl ? { suggestedImportUrl: importUrl } : {}),
            ...(frozen ? { frozenImportUrl: frozen } : {}),
        };
        if (change) {
            change(doc);
        }
    });
    return handle;
};
